import { memo } from 'react';

interface ComboHeaderProps {
  comboName: string;
}

const ComboHeader = memo(({ comboName }: ComboHeaderProps) => (
  <div>
    <h4>
      <strong>Economize levando mais!</strong>
    </h4>
    <span className="combo-subtitle">Combo {comboName}</span>
  </div>
));

ComboHeader.displayName = 'ComboHeader';

export default ComboHeader;
